export function getScrollBarWidth(navScrollBarWidth, currentZoomLevel, nextZoomLevel) {
    if (navScrollBarWidth !== 0 && currentZoomLevel === nextZoomLevel) {
        return [navScrollBarWidth, currentZoomLevel];
    }
    currentZoomLevel = nextZoomLevel;
    var scrollDiv = document.createElement('div');
    scrollDiv.setAttribute('style', 'width: 100px; height: 100px; overflow: scroll; position: absolute; top: -999px;');
    var contentDiv = document.createElement('p');
    contentDiv.setAttribute('style', 'width: 100px; height: 200px;');
    scrollDiv.appendChild(contentDiv);
    document.body.appendChild(scrollDiv);
    navScrollBarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return [navScrollBarWidth, currentZoomLevel];
}
//# sourceMappingURL=CoherenceNav.utilities.js.map